export const POST_9_DAN_MIDPOINT_ELO = 2340;
export const POST_9_DAN_STEEPNESS_FACTOR = 0.01;
